import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import RouteGuard from '../../../routes/RouteGuard';
import Careerbuilder from '../careerbuilder/CareerBuilder';
import CareerbuilderEdgeBoard from '../careerbuilderedge';
import CandidateProfile from '../components/CandidateProfile';
import CVLibrary from '../cvlibrary';
import CWJobs from '../cwjobs/CWJobs';
import DiceSearch from '../dice';
import Jobserve from '../jobserve';
import JobSite from '../jobsite';
import MonsterSearch from '../monster';
import SourcingBots from '../sourcingBots/SourcingBots';
import TechFetchSearch from '../techfetch';
export const NativeSearchRoutes = () => (
  <Routes>
    <Route
      path="dice"
      element={
        <RouteGuard>
          <DiceSearch />
        </RouteGuard>
      }
    />
    <Route
      path="techfetch"
      element={
        <RouteGuard>
          <TechFetchSearch />
        </RouteGuard>
      }
    />
    <Route
      path="monster"
      element={
        <RouteGuard>
          <MonsterSearch />
        </RouteGuard>
      }
    />
    <Route
      path="careerBuilder"
      element={
        <RouteGuard>
          <Careerbuilder />
        </RouteGuard>
      }
    />

    <Route
      path="careerbuilderedge"
      element={
        <RouteGuard>
          <CareerbuilderEdgeBoard />
        </RouteGuard>
      }
    />
    <Route
      path="cwJobs"
      element={
        <RouteGuard>
          <CWJobs />
        </RouteGuard>
      }
    />
    <Route
      path="jobsite"
      element={
        <RouteGuard>
          <JobSite />
        </RouteGuard>
      }
    />
    <Route
      path="jobServe"
      element={
        <RouteGuard>
          <Jobserve />
        </RouteGuard>
      }
    />
    <Route
      path="cvlibrary"
      element={
        <RouteGuard>
          <CVLibrary />
        </RouteGuard>
      }
    />
    <Route
      path="/candidate-profile/:candidateId/:emailId"
      element={
        <RouteGuard>
          <CandidateProfile />
        </RouteGuard>
      }
    />
    <Route
      path="/sourcing-bots"
      element={
        <RouteWithTitle title="Sourcing Bots- Wisestep">
          <RouteGuard>
            <SourcingBots />
          </RouteGuard>
        </RouteWithTitle>
      }
    />
  </Routes>
);
